import { GraniteButton } from 'components/V2/Button/GraniteButton';

const UploaderContent = () => {
  return (
    <>
      <p className="mb-0.5 mt-6 text-center text-xs font-bold text-content-base-default">
        Drag & drop or click to upload
      </p>
      <p className="mb-2.5 text-center text-xs font-medium text-content-base-subdued">
        Supported logo formats: PNG, SVG or JPG. Max size 25MB.
      </p>
      <GraniteButton size="small" variant="secondary">
        Upload
      </GraniteButton>
    </>
  );
};

export default UploaderContent;
